<template>
  <div class="order">
    <!-- 初始的产品列表 -->
    <div class="products" v-for="(item, index) in product" :key="index">
      <h1 class="title">{{ $t('meg.product') }}{{ index + 1 }}</h1>
      <hr style="margin-left: 43px;margin-right: 29px;margin-top: 12px;">
      <div
        style="margin-top: 28px;padding-bottom: 28px;border-bottom: 1px solid #DDDDDD;margin-left: 55px;margin-right: 50px;">
        <el-form :model="item" :inline="true" class="demo-form-inline"
          style="display: flex;justify-content: space-around;">
          <el-form-item :label="$t('meg.productName')" required>
            <el-input clearable v-model="item.productName" />
          </el-form-item>
          <el-form-item :label="$t('meg.productType')" required>
            <el-select clearable v-model="item.productType" placeholder="请选择">
              <el-option v-for="dict in categoryData" :key="dict.dictValue" :label="dict.dictLabel"
                :value="dict.dictValue" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-left: 55px;margin-right: 50px;">
        <el-table class="orderTable" :data="item.tableList" style="max-width: 100%;overflow-x:auto"
          :header-cell-style="{ 'background': '#F7F9FD !important', 'color': '#333', 'height': '56px !important' }">
          <el-table-column :label="$t('meg.color')">
            <template #default="scope">
              <el-input size="small" v-model="scope.row.skuColor" />
            </template>
          </el-table-column>
          <el-table-column :label="$t('meg.quantity')" prop="quantity" >
            <template #default="scope">
              {{ calculateTotal(scope.row,item) }}
            </template>
          </el-table-column>
          <el-table-column v-for="(count, index) in item.inputCounts" :key="index">
            <template #header>
              <el-input size="small" v-model="item.inputCounts[index]" />
            </template>
            <template #default="scope">
              <el-input size="small" v-model="scope.row[item.inputCounts[index]]" />
            </template>
          </el-table-column>
          <el-table-column>
            <template #header>
              <el-button class="chimaBtn" @click="addInput(index)">+新增尺码</el-button>
              <el-button class="chimaBtn" @click="deleteSize(index)">-删除尺码</el-button>
            </template>
            <template #default="scope">
              <el-button link type="primary" size="small" @click.prevent="deleteRow(scope.$index, item.tableList)">
                {{ $t('meg.deletecolor') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <p class="colorStyle" @click="addTableRow(item.tableList)">
        +{{ $t('meg.addcolor') }}</p>
      <div style="margin-top: 39px;">
        <el-form>
          <el-form-item :label="$t('meg.preparation')" required style="margin-left: 65px;">
            <div style="display: flex;flex-direction: column;">
              <el-upload v-model="item.documentation" class="upload-demo" :action="uploadUrl"
                :headers="{ Authorization: acctoken }" ref="upload" :limit="1"
                :on-success="response => handleSuccess(response, item)" :before-upload="beforePDFUpload"
                :on-exceed="handleExceed" :on-error="handleError" accept=".pdf">
                <el-button class="uploadBtn">{{ $t('meg.upload') }}</el-button>
                <p
                  style="font-size: 14px;font-family: PingFang SC, PingFang SC;font-weight: 500;color: #777777;margin-left: 10px;">
                  {{ $t('meg.Ten') }}</p>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item :label="$t('meg.productImg')" required style="margin-left: 65px;margin-top: 18px;">
            <div style="display: flex;flex-direction: column;">
              <el-upload v-model="item.pictures" class="upload-demo" :headers="{ Authorization: acctoken }"
                :action="uploadUrl" :before-upload="beforeImageUpload" :accept="'image/jpeg,image/png'"
                :on-success="response => handleImgSuccess(response, item)" :on-exceed="handleExceed"
                :on-error="handleError">
                <el-button class="uploadBtn">{{ $t('meg.upload') }}</el-button>
                <p
                  style="font-size: 14px;font-family: PingFang SC, PingFang SC;font-weight: 500;color: #777777;margin-left: 10px;">
                  {{ $t('meg.jpgexceed') }}</p>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="addProduct" >
      <el-button @click="addDuplicateProduct" link style="font-size: 16px;font-family: PingFang SC, PingFang SC;font-weight: bold;color: #002FA7;">
        +{{ $t('meg.AddProduct') }}
      </el-button>
      <el-button @click="deleteProduct" :disabled=" product.length==1"  link style="font-size: 16px;font-family: PingFang SC, PingFang SC;font-weight: bold;color: #002FA7;">
        -{{ $t('meg.deleteProduct') }}
      </el-button>
    </div>
    <div class="delivery">
      <h1 class="title">{{ $t('meg.DeliveryDate') }}</h1>
      <hr style="margin-left: 43px;margin-right: 29px;margin-top: 12px;">
      <div style="margin-top: 27px;">
        <el-form :model="productList" :inline="true" class="demo-form-inline"
          style="display: flex;justify-content: space-around;">
          <el-form-item :label="$t('meg.Shipping')" required>
            <el-date-picker placeholder="请选择时间" type="datetime" clearable v-model="productList.deliveryTime" />
          </el-form-item>
          <el-form-item :label="$t('meg.deliveryArea')" required>
            <el-select clearable v-model="productList.deliveryArea" placeholder="请选择">
              <el-option-group v-for="group in country" :key="group.label" :label="group.label">
                <el-option v-for="item in group.options" :key="item.value" :label="item.label"
                  :value="item.label"></el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="contract">
      <h1 class="title">{{ $t('meg.Contract') }}</h1>
      <hr style="margin-left: 43px;margin-right: 29px;margin-top: 12px;">
      <div style="margin-top: 22px;">
        <el-form>
          <el-form-item :label="$t('meg.contract')" required style="margin-left: 65px;">
            <div style="display: flex;flex-direction: column;">
              <el-upload v-model="productList.orderContract" class="upload-demo" :action="uploadUrl"
                :headers="{ Authorization: acctoken }" ref="upload" :limit="1" :on-success="orderContractSuccess"
                :before-upload="beforePDFUpload" :on-exceed="handleExceed" :on-error="handleError" accept=".pdf">
                <el-button class="uploadBtn">{{ $t('meg.upload') }}</el-button>
                <p
                  style="font-size: 14px;font-family: PingFang SC, PingFang SC;font-weight: 500;color: #777777;margin-left: 10px;">
                  {{ $t('meg.Ten') }}</p>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="orderBtnBox">
      <h1 class="orderBtnh">{{ $t('meg.Confirmation') }}</h1>
      <p
        style="text-align: left;margin-left: 31px;margin-right: 34px;margin-top: 16px;font-size: 14px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 400;color: #777777;">
        {{ $t('meg.reminded') }}</p>
      <el-button class="orderBtn" @click="orderBtn">{{ $t('meg.confirmOrder') }}</el-button>
      <el-button class="backBtn" @click="backBtn">{{ $t('meg.back') }}</el-button>
    </div>
  </div>
</template>

<script setup>
import { computed, reactive, ref, toRefs, onMounted } from 'vue'
import { clientPlaceAnOrder, getDicts } from "@/api/order.js"
import { ElMessage } from 'element-plus'
import { useRouter, useRoute } from 'vue-router';


const categoryData = ref([])
const router = useRouter()
const country = reactive([
  {
    label: '热门国家',
    options: [{ value: 'China', label: '中国' },]
  },
  {
    label: "所有国家",
    options: [
      { value: "Angola", label: "安哥拉" },
      { value: "Afghanistan", label: "阿富汗" },
      { value: "Albania", label: "阿尔巴尼亚" },
      { value: "Algeria", label: "阿尔及利亚" },
      { value: "Andorra", label: "安道尔共和国" },
      { value: "Anguilla", label: "安圭拉岛" },
      { value: "Antigua and Barbuda", label: "安提瓜和巴布达" },
      { value: "Argentina", label: "阿根廷" },
      { value: "Armenia", label: "亚美尼亚" },
      { value: "Ascension", label: "阿森松" },
      { value: "Australia", label: "澳大利亚" },
      { value: "Austria", label: "奥地利" },
      { value: "Azerbaijan", label: "阿塞拜疆" },
      { value: "Bahamas", label: "巴哈马" },
      { value: "Bahrain", label: "巴林" },
      { value: "Bangladesh", label: "孟加拉国" },
      { value: "Barbados", label: "巴巴多斯" },
      { value: "Belarus", label: "白俄罗斯" },
      { value: "Belgium", label: "比利时" },
      { value: "Belize", label: "伯利兹" },
      { value: "Benin", label: "贝宁" },
      { value: "Bermuda Is", label: "百慕大群岛" },
      { value: "Bolivia", label: "玻利维亚" },
      { value: "Botswana", label: "博茨瓦纳" },
      { value: "Brazil", label: "巴西" },
      { value: "Brunei", label: "文莱" },
      { value: "Bulgaria", label: "保加利亚" },
      { value: "Burkina Faso", label: "布基纳法索" },
      { value: "Burma", label: "缅甸" },
      { value: "Burundi", label: "布隆迪" },
      { value: "Cameroon", label: "喀麦隆" },
      { value: "Canada", label: "加拿大" },
      { value: "Cayman Is", label: "开曼群岛" },
      { value: "Central African Republic", label: "中非共和国" },
      { value: "Chad", label: "乍得" },
      { value: "Chile", label: "智利" },
      { value: "China", label: "中国", disabled: true },
      { value: "Colombia", label: "哥伦比亚" },
      { value: "Congo", label: "刚果" },
      { value: "Cook Is", label: "库克群岛" },
      { value: "Costa Rica", label: "哥斯达黎加" },
      { value: "Cuba", label: "古巴" },
      { value: "Cyprus", label: "塞浦路斯" },
      { value: "Czech Republic", label: "捷克" },
      { value: "Denmark", label: "丹麦" },
      { value: "Djibouti", label: "吉布提" },
      { value: "Dominica Rep", label: "多米尼加共和国" },
      { value: "Ecuador", label: "厄瓜多尔" },
      { value: "Egypt", label: "埃及" },
      { value: "EI Salvador", label: "萨尔瓦多" },
      { value: "Estonia", label: "爱沙尼亚" },
      { value: "Ethiopia", label: "埃塞俄比亚" },
      { value: "Fiji", label: "斐济" },
      { value: "Finland", label: "芬兰" },
      { value: "France", label: "法国" },
      { value: "French Guiana", label: "法属圭亚那" },
      { value: "French Polynesia", label: "法属玻利尼西亚" },
      { value: "Gabon", label: "加蓬" },
      { value: "Gambia", label: "冈比亚" },
      { value: "Georgia", label: "格鲁吉亚" },
      { value: "Ghana", label: "加纳" },
      { value: "Gibraltar", label: "直布罗陀" },
      { value: "Greece", label: "希腊" },
      { value: "Grenada", label: "格林纳达" },
      { value: "Guam", label: "关岛" },
      { value: "Guatemala", label: "危地马拉" },
      { value: "Guinea", label: "几内亚" },
      { value: "Guyana", label: "圭亚那" },
      { value: "Haiti", label: "海地" },
      { value: "Honduras", label: "洪都拉斯" },
      { value: "Hungary", label: "匈牙利" },
      { value: "Iceland", label: "冰岛" },
      { value: "India", label: "印度" },
      { value: "Indonesia", label: "印度尼西亚" },
      { value: "Iran", label: "伊朗" },
      { value: "Iraq", label: "伊拉克" },
      { value: "Ireland", label: "爱尔兰" },
      { value: "Israel", label: "以色列" },
      { value: "Italy", label: "意大利" },
      { value: "Ivory Coast", label: "科特迪瓦" },
      { value: "Jamaica", label: "牙买加" },
      { value: "Japan", label: "日本" },
      { value: "Jordan", label: "约旦" },
      { value: "Kampuchea (Cambodia )", label: "柬埔寨" },
      { value: "Kazakstan", label: "哈萨克斯坦" },
      { value: "Kenya", label: "肯尼亚" },
      { value: "Korea", label: "韩国" },
      { value: "Kuwait", label: "科威特" },
      { value: "Kyrgyzstan", label: "吉尔吉斯坦" },
      { value: "Laos", label: "老挝" },
      { value: "Latvia", label: "拉脱维亚" },
      { value: "Lebanon", label: "黎巴嫩" },
      { value: "Lesotho", label: "莱索托" },
      { value: "Liberia", label: "利比里亚" },
      { value: "Libya", label: "利比亚" },
      { value: "Liechtenstein", label: "列支敦士登" },
      { value: "Lithuania", label: "立陶宛" },
      { value: "Luxembourg", label: "卢森堡" },
      { value: "Madagascar", label: "马达加斯加" },
      { value: "Malawi", label: "马拉维" },
      { value: "Malaysia", label: "马来西亚" },
      { value: "Maldives", label: "马尔代夫" },
      { value: "Mali", label: "马里" },
      { value: "Malta", label: "马耳他" },
      { value: "Mariana Is", label: "马里亚那群岛" },
      { value: "Martinique", label: "马提尼克" },
      { value: "Mauritius", label: "毛里求斯" },
      { value: "Mexico", label: "墨西哥" },
      { value: "Moldova", label: "摩尔多瓦" },
      { value: "Monaco", label: "摩纳哥" },
      { value: "Mongolia", label: "蒙古" },
      { value: "Montserrat Is", label: "蒙特塞拉特岛" },
      { value: "Morocco", label: "摩洛哥" },
      { value: "Mozambique", label: "莫桑比克" },
      { value: "Namibia", label: "纳米比亚" },
      { value: "Nauru", label: "瑙鲁" },
      { value: "Nepal", label: "尼泊尔" },
      { value: "Netheriands Antilles", label: "荷属安的列斯" },
      { value: "Netherlands", label: "荷兰" },
      { value: "New Zealand", label: "新西兰" },
      { value: "Nicaragua", label: "尼加拉瓜" },
      { value: "Niger", label: "尼日尔" },
      { value: "Nigeria", label: "尼日利亚" },
      { value: "North Korea", label: "朝鲜" },
      { value: "Norway", label: "挪威" },
      { value: "Oman", label: "阿曼" },
      { value: "Pakistan", label: "巴基斯坦" },
      { value: "Panama", label: "巴拿马" },
      { value: "Papua New Cuinea", label: "巴布亚新几内亚" },
      { value: "Paraguay", label: "巴拉圭" },
      { value: "Peru", label: "秘鲁" },
      { value: "Philippines", label: "菲律宾" },
      { value: "Poland", label: "波兰" },
      { value: "Portugal", label: "葡萄牙" },
      { value: "Puerto Rico", label: "波多黎各" },
      { value: "Qatar", label: "卡塔尔" },
      { value: "Reunion", label: "留尼旺" },
      { value: "Romania", label: "罗马尼亚" },
      { value: "Russia", label: "俄罗斯" },
      { value: "Saint Lueia", label: "圣卢西亚" },
      { value: "Saint Vincent", label: "圣文森特岛" },
      { value: "Samoa Eastern", label: "东萨摩亚(美)" },
      { value: "Samoa Western", label: "西萨摩亚" },
      { value: "San Marino", label: "圣马力诺" },
      { value: "Sao Tome and Principe", label: "圣多美和普林西比" },
      { value: "Saudi Arabia", label: "沙特阿拉伯" },
      { value: "Senegal", label: "塞内加尔" },
      { value: "Seychelles", label: "塞舌尔" },
      { value: "Sierra Leone", label: "塞拉利昂" },
      { value: "Singapore", label: "新加坡" },
      { value: "Slovakia", label: "斯洛伐克" },
      { value: "Slovenia", label: "斯洛文尼亚" },
      { value: "Solomon Is", label: "所罗门群岛" },
      { value: "Somali", label: "索马里" },
      { value: "South Africa", label: "南非" },
      { value: "Spain", label: "西班牙" },
      { value: "SriLanka", label: "斯里兰卡" },
      { value: "St.Lucia", label: "圣卢西亚" },
      { value: "St.Vincent", label: "圣文森特" },
      { value: "Sudan", label: "苏丹" },
      { value: "Suriname", label: "苏里南" },
      { value: "Swaziland", label: "斯威士兰" },
      { value: "Sweden", label: "瑞典" },
      { value: "Switzerland", label: "瑞士" },
      { value: "Syria", label: "叙利亚" },
      { value: "Tajikstan", label: "塔吉克斯坦" },
      { value: "Tanzania", label: "坦桑尼亚" },
      { value: "Thailand", label: "泰国" },
      { value: "Togo", label: "多哥" },
      { value: "Tonga", label: "汤加" },
      { value: "Trinidad and Tobago", label: "特立尼达和多巴哥" },
      { value: "Tunisia", label: "突尼斯" },
      { value: "Turkey", label: "土耳其" },
      { value: "Turkmenistan", label: "土库曼斯坦" },
      { value: "Uganda", label: "乌干达" },
      { value: "Ukraine", label: "乌克兰" },
      { value: "United Arab Emirates", label: "阿拉伯联合酋长国" },
      { value: "United Kiongdom", label: "英国" },
      { value: "United States of America", label: "美国" },
      { value: "Uruguay", label: "乌拉圭" },
      { value: "Uzbekistan", label: "乌兹别克斯坦" },
      { value: "Venezuela", label: "委内瑞拉" },
      { value: "Vietnam", label: "越南" },
      { value: "Yemen", label: "也门" },
      { value: "Yugoslavia", label: "南斯拉夫" },
      { value: "Zimbabwe", label: "津巴布韦" },
      { value: "Zaire", label: "扎伊尔" },
      { value: "Zambia", label: "赞比亚" }
    ]
  }
])

onMounted(() => {
  getDicts("product_category").then(res => {
    categoryData.value = res.data.data
  })
})
// 用于存储已有产品的数组
const productList = ref([{
  orderContract: "",
  deliveryArea: "",
  deliveryTime: "",
}])
const pdfFiles = ref([]);
const acctoken = ref(localStorage.getItem("access_token"))
const uploadUrl = ref('/dev-api' + '/file/upload')
const contractUrl = ref("")
const product = ref([{
  productName: "",
  productType: "",
  documentation: "",
  pictures: "",
  // inputCounts:[],
  inputCounts: [''],
  tableList: [{
    skuColor: ""
  }]
}])
// // 用于存储每个表格的输入框数量
const inputCounts = ref([''])

// 点击新增尺码时，在输入框数量数组中增加一个计数
const addInput = (productIndex) => {
  product.value[productIndex].inputCounts.push('')
}

const calculateTotal = (row,item) => {
  let total = 0;
  item.inputCounts.forEach(count => {
    total += Number(row[count]) || 0;
  })
  return total
}

const addDuplicateProduct = () => {
  product.value.push({
    productName: "",
    productType: "",
    documentation: "",
    inputCounts: [''],
    pictures: [],
    tableList: [],
  })
}

const deleteProduct = () => {
  // Get the index of the last product in the array
  const lastIndex = product.value.length - 1;

  // Ensure that there is at least one product before attempting to delete
  if (lastIndex >= 0) {
    // Remove the last product from the array
    product.value.splice(lastIndex, 1);
  } else {
    // Handle the case where there are no products to delete
    console.warn('No products to delete');
  }
};

const backBtn = () => {
  router.go(-1)
}

const orderBtn = () => {
  let newArr = JSON.parse(JSON.stringify(product.value));
  let headerArr = JSON.parse(JSON.stringify(inputCounts.value));
  let newArrList = [];
  newArr.map((item, index) => {
    item.inputCounts.map((citem, index) => {
      newArrList.push([item.tableList.skuColor, citem, item.tableList[index][""]]);
    })
  });
  let obj = {
    orderContract: contractUrl.value,
    deliveryArea: productList.value.deliveryArea,
    deliveryTime: productList.value.deliveryTime,
    commodityManagesVo: null
  }
  obj.commodityManagesVo = product.value
  clientPlaceAnOrder(obj).then(res => {
    if (res.data.code == 200) {
      ElMessage.success("下单成功")
      router.go(-1)
    }
  })
}

// 点击新增颜色时，向表格数据数组中添加新的对象
const addTableRow = (list) => {
  list.push({ skuColor: '' })
}
// 添加一个函数来根据索引删除尺码
const deleteSize = (sizeIndex) => {
  // 从 inputCounts 数组中删除给定索引的尺码
  product.value[sizeIndex].inputCounts.pop();
  // 此外，如果使用了相应的 Scope 数据，也要删除它
  // 处理任何其他需要删除的尺码内容
}
const deleteRow = (index, list) => {
  list.splice(index, 1)
}
//制单文件pdf
const beforePDFUpload = (file) => {
  const isPDF = file.type === 'application/pdf';
  const isLt10M = file.size / 1024 / 1024 <= 10;

  if (!isPDF) {
    ElMessage.error('只能上传PDF文件');
  }
  if (!isLt10M) {
    ElMessage.error('文件大小不能超过10MB');
  }

  return isPDF && isLt10M;
}

const handleExceed = (files, fileList) => {
  ElMessage.warning('只能上传一个PDF文件');
};

const handleSuccess = (response, currentItem) => {
  currentItem.documentation = response.data.url
};

const handleImgSuccess = (response, cItem) => {
  // 假设 response.data.url 是上传图片的 URL
  const imageUrl = response.data.url;

  // 如果 cItem.pictures 不存在或不是数组，则将其初始化为空数组
  if (!Array.isArray(cItem.pictures)) {
    cItem.pictures = [];
  }
  // 将新的图片 URL 添加到 cItem.pictures 数组中
  cItem.pictures.push({
    name: response.data.name,
    url: imageUrl
  });
}

const handleError = (error, file, fileList) => {
  // Handle upload error
};

const orderContractSuccess = (response, file, fileList) => {
  productList.value[0].orderContract = response.data.url;
  contractUrl.value = productList.value[0].orderContract
}

//图片上传
const beforeImageUpload = (file) => {
  const isJPGorPNG = file.type === 'image/jpeg' || file.type === 'image/png';
  const isLt5M = file.size / 1024 / 1024 < 5;

  if (!isJPGorPNG) {
    ElMessage.error('只能上传JPG或PNG格式的图片');
  }
  if (!isLt5M) {
    ElMessage.error('图片大小不能超过5MB');
  }

  return isJPGorPNG && isLt5M;
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.order {
  background: #F8F8F8;
  /* height: 995px; */
  overflow: hidden;
}

.products {
  margin: 35px 360px;
  /* height: 565px; */
  padding-bottom: 76px;
  background: #FFFFFF;
  border-radius: 10px 10px 10px 10px;
  overflow: hidden;
  margin-bottom: 0%;
}

.title {
  font-size: 20px;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  color: #333333;
  text-align: left;
  margin-left: 42px;
  margin-top: 20px;
}

::v-deep .el-form-item__label {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  color: #333333;
}

::v-deep .el-input__wrapper {
  width: 246px;
  height: 38px;
  background: #FFFFFF;
  border-radius: 4px 4px 4px 4px;
}

.orderTable ::v-deep .el-input {
  width: 74px;
  /* height: 34px; */
  background: #FFFFFF;
  border-radius: 2px 2px 2px 2px;
}

.orderTable ::v-deep .el-input__wrapper {
  width: 74px;
  height: 34px;
  background: #FFFFFF;
  border-radius: 2px 2px 2px 2px;
}

.uploadBtn {
  width: 131px;
  height: 38px;
  background: #002FA7;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #DDDDDD;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
}

.addProduct {
  margin: 12px 360px;
  height: 54px;
  background: #FFFFFF;
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
  text-align: left;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  color: #002FA7;
  line-height: 54px;
  padding-left: 65px;
}

.delivery {
  margin: 12px 360px;
  /* height: 156px; */
  background: #FFFFFF;
  border-radius: 10px 10px 10px 10px;
  overflow: hidden;
  padding-bottom: 58px;
}

.contract {
  margin: 12px 360px;
  /* height: 231px; */
  background: #FFFFFF;
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
  overflow: hidden;
  padding-bottom: 92px;
}

.colorStyle {
  text-align: left;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  color: #002FA7;
  margin-top: 12px;
  margin-left: 74px;
  cursor: pointer;
}

.chimaBtn {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  color: #002FA7;
  padding: 8px;
}

.orderBtnBox {
  width: 275px;
  /* height: 361px; */
  padding-bottom: 30px;
  background: #FFFFFF;
  border-radius: 10px 10px 10px 10px;
  overflow: hidden;
  position: fixed;
  top: 135px;
  right: 66px;
}

.orderBtnh {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  color: #333333;
  text-align: left;
  margin-left: 31px;
  margin-top: 20px;
}

.orderBtn {
  width: 210px;
  height: 49px;
  background: #002FA7;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  font-size: 20px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: 65px;
}

.backBtn {
  width: 210px;
  height: 49px;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #DDDDDD;
  font-size: 20px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  margin-left: 0;
  margin-top: 16px;
}
</style>
